import Card from '@mui/material/Card';
import {
  blue,
  deepOrange,
  deepPurple,
  green,
  grey,
  orange,
  pink,
  red,
  teal,
} from '@mui/material/colors';
import MDBox from 'components/MDBox';
import OcpLineChart from 'layouts/OccupancyAverages/components/OcpLineChart';
import { useDispatch } from 'react-redux';
import { brandColors } from 'types/colors';
import { LabelType } from '../../../components/Charts/LineChart';

const FormattedChart = ({ title, datasets, isRange, isPopUp, sensorId }) => {
  const COLORS_FOR_REGULAR_CHARTS = [
    brandColors.BLUE,
    brandColors.GREY,
    brandColors.TURQUOISE,
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    grey[900],
    grey[500],
    blue[600],
  ];
  const dispatch = useDispatch();

  const COLORS_FOR_RANGE_CHARTS = [
    blue[200],
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    red[300],
    orange[400],
    grey[500],
    deepPurple[600],
    blue[600],
  ];

  // console.log('sensorPage/FormattedChart.js re-render');

  return (
    <Card>
      <MDBox margin={1} style={{ height: '70vh' }}>
        <OcpLineChart
          title={title}
          detailed={true}
          horizontalLabels={undefined}
          datasets={datasets}
          isZoomEnabled={true}
          isLineCurved={false}
          xAxis={{ labelType: LabelType.Date, show: true }}
          isPopUp={isPopUp}
          colors={
            isRange === undefined || isRange === false
              ? COLORS_FOR_REGULAR_CHARTS
              : COLORS_FOR_RANGE_CHARTS
          }
          sensorId={sensorId}
        />
      </MDBox>
    </Card>
  );
};

export default FormattedChart;
